import { render, staticRenderFns } from "./ConcernElementsV9.vue?vue&type=template&id=6f88a474&"
import script from "./ConcernElementsV9.vue?vue&type=script&lang=js&"
export * from "./ConcernElementsV9.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports